import React, {type FC} from 'react';
import {IProduct, IProductOption} from '../../../../../types/galleryTypes';
import {useGlobals, withGlobals} from '../../../../../globalPropsContext';
import {MobileDrawer} from '@wix/wix-ui-tpa/cssVars';
import {ProductQuickAddContent} from '../ProductQuickAddContent/ProductQuickAddContent';
import s from './ProductQuickAddMobile.scss';
import {classes as mobileDrawerStylable} from './ProductQuickAddMobile.st.css';
import classNames from 'classnames';

export const ProductQuickAddMobileDataHooks = {
  Root: 'product-quick-add-mobile-root',
};
export interface IProductQuickAddMobileProps {
  product: IProduct;
  options: IProductOption[];
  productIndex: number;
  quantity: number;
}

const ProductQuickAddMobileComp: FC<IProductQuickAddMobileProps> = ({product, options, productIndex, quantity}) => {
  const {closeQuickAdd, host, isEditorMode, isRTL} = useGlobals();

  /* istanbul ignore next */
  const dir = isRTL ? 'rtl' : 'ltr';

  return (
    <MobileDrawer
      onRequestClose={/* istanbul ignore next */ () => closeQuickAdd(product.id)}
      className={classNames(s.root, host.id, mobileDrawerStylable.mobileDrawer)}
      data-hook={`${ProductQuickAddMobileDataHooks.Root}-${productIndex}`}
      focusTrap={!isEditorMode}
      isOpen
      appendToBody>
      <div className={classNames(s.stopBodyYScroll, s.quickAddMobileScrollContainer)} dir={dir}>
        <ProductQuickAddContent product={product} options={options} quantity={quantity} />
      </div>
    </MobileDrawer>
  );
};

export const ProductQuickAddMobile = withGlobals(ProductQuickAddMobileComp);
